module.exports = __webpack_public_path__ + "img/595225514.a2eca9fd.jpg";